if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        setNavBtn();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

/**
 * ナビゲーションボタンの設定
 */
function setNavBtn() {
  // activeなイメージを取得
  let activeImage = document.querySelector(".product-media-gallery img.active");
  if( !activeImage ) {
    activeImage = document.querySelector(".product-media-gallery img:first-child");
  }
  const initImgId = activeImage.dataset.mediaId;

  // ドットの初期化
  const dottBtns = document.querySelectorAll('.product-media-modal__nav .nav__btn');
  dottBtns.forEach(element => {
    element.classList.add("invisible");
    element.classList.remove("current", "next2", "next3", "next4");
  });

  // activeに対応するドットを取得
  const currentImg = document.querySelector('.product-media-modal__nav .nav__btn[data-media-thumb-id="' + initImgId + '"]');
  currentImg.classList.add("current");
  currentImg.classList.remove("invisible");

  let prevElem = currentImg;
  let nextElem = currentImg;

  for (let index = 2; index <= 4; index++) {
    if(prevElem) {
      prevElem = prevElem.previousElementSibling;
      if(prevElem){
        prevElem.classList.remove("invisible");
        prevElem.classList.add('next' + index);
      }
    }
    if(nextElem) {
      nextElem = nextElem.nextElementSibling;
      if(nextElem) {
        nextElem.classList.remove("invisible");
        nextElem.classList.add('next' + index);
      }
    }
  }
}

/**
 * イメージスクロール時
 */
function imageScroll() {

  const images = document.querySelectorAll('.product-media-gallery .global-media-settings');
  const modal = document.querySelector(".product-media-modal__dialog");

  function addScrolledClassToTopImage() {
    let highestVisibleImage = null;
    let highestVisiblePosition = Infinity;

    images.forEach(image => {
      const rect = image.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const imageTop = rect.top + scrollTop;
      const imageBottom = rect.bottom + scrollTop;

      if (imageTop < window.innerHeight && imageBottom > 0 && imageTop < highestVisiblePosition) {
        highestVisibleImage = image;
        highestVisiblePosition = imageTop;
      }
    });

    images.forEach(image => {
      image.classList.remove('active');
    });

    if (highestVisibleImage) {
      highestVisibleImage.classList.add('active');
      setNavBtn();
    }
  }

  modal.addEventListener('scroll', addScrolledClassToTopImage);
  addScrolledClassToTopImage(); // 初期化

}
window.addEventListener('DOMContentLoaded', imageScroll);


/**
 * ナビゲーションボタンの位置設定
 */
function clickBtn(mediaId) {
  document.querySelectorAll(".product-media-gallery img")
  .forEach((element) => {
    element.classList.remove('active');
  });
  const activeMedia = document.querySelector(`.product-media-gallery img[data-media-id="${mediaId}"]`);
  activeMedia.classList.add('active');
  activeMedia.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

  setNavBtn();

  return false;

}

